export default __webpack_public_path__ + "static/media/joinus.874fb128.png";